export const formatPhoneNumber = (num, extension) => {
  if (!num) {
    return "";
  }

  num = num.replaceAll(" ", "");
  const countryCode = num.slice(0, 1);
  const areaCode = num.slice(1, 4);
  const phoneNumber = num.slice(4, num.length);

  const phoneNumberFirstThree = phoneNumber.slice(0, 3);
  const phoneNumberLastFour = phoneNumber.slice(3, phoneNumber.length);

  const extensionParth = extension ? `;${extension}` : "";

  return `+${countryCode} (${areaCode}) ${phoneNumberFirstThree}-${phoneNumberLastFour}${extensionParth}`;
};
